const numberWithCommas = (x) => x.toLocaleString('en-US'); // x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',');
export default numberWithCommas;
//# sourceMappingURL=numberWithCommas.js.map